import { render, staticRenderFns } from "./EditSecretsForm.vue?vue&type=template&id=6849e806"
import script from "./EditSecretsForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditSecretsForm.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports